import { render } from "./TodayIcon.vue?vue&type=template&id=376f1fbd"
const script = {}
script.render = render

export default script